'use client';

import { Dispatch, SetStateAction, useMemo } from 'react';
import { cn } from '@/helpers/common';
import IconKebab from '@/components/svgs/icons/kebab-icon';

import { ROUTES } from '@/constants/routes/default';
import { signOut } from 'next-auth/react';
import Dropdown from '../Dropdowns/Dropdown';

const HeaderDropdownKG = ({ session, isSighInPath }: { session: any; isSighInPath?: boolean }) => {
  const options = useMemo(() => {
    let result = [];

    if (session) {
      result = [
        { type: 'link', title: 'Search all jobs', href: ROUTES.jobs, withDivider: true },
        { type: 'link', title: 'Partnerships', href: ROUTES.partners, withDivider: false },
        {
          type: 'link',
          title: 'Career Profile',
          href: ROUTES.profile,
          withDivider: false,
        },
        {
          type: 'button',
          title: 'Sign Out',
          onClick: () => signOut(),
          withDivider: true,
        },
      ];
    } else {
      result = [
        {
          type: 'link',
          title: 'Search all jobs',
          href: ROUTES.jobs,
          withDivider: !!session,
        },
        { type: 'link', title: 'Partnerships', href: ROUTES.partners, withDivider: false },
        {
          type: 'link',
          title: isSighInPath ? 'Sign Up' : 'Sign In',
          href: ROUTES[isSighInPath ? 'signup' : 'signin'],
          withDivider: false,
        },
      ];
    }

    return result;
  }, [session, isSighInPath]);

  return (
    <Dropdown
      rootCn={''}
      listCn={'max-w-50 right-0 bg-white py-2 border border-kg-athens-gray rounded-xs'}
      elementCn={'text-sm h-9 px-4 flex items-center bg-white hover:bg-kg-athens-gray-light'}
      dividerCn={'border-kg-athens-gray'}
      listHeader={
        session && session?.user?.email ? (
          <div
            className={cn(
              'px-4 text-xs text-kg-mako overflow-hidden truncate whitespace-nowrap text-ellipsis',
            )}
          >
            {session?.user?.email}
          </div>
        ) : null
      }
      options={options}
    >
      {({
        setIsOpen,
        isOpen,
        listId,
      }: {
        setIsOpen: Dispatch<SetStateAction<boolean>>;
        isOpen: boolean;
        listId: string;
      }) => (
        <button
          aria-label="Menu"
          aria-expanded={isOpen}
          aria-controls={isOpen ? listId : undefined}
          onClick={() => {
            setIsOpen((prev) => !prev);
          }}
          className={cn(
            'flex items-center justify-center relative p-2 [&>svg>path]:fill-kg-black-pearl! no-underline default-transition rounded-sm bg-white border border-kg-athens-gray hover:[&>svg>path]:fill-kg-fun-blue!',
            isOpen && '[&>svg>path]:fill-kg-black-pearl!',
          )}
        >
          <IconKebab
            aria-hidden="true"
            className="shrink-0 [&>rect]:fill-current [&>rect]:transition-all [&>rect]:duration-300"
          />
        </button>
      )}
    </Dropdown>
  );
};

export default HeaderDropdownKG;
